import { PropsWithChildren, createContext } from "react";

import { useLocalStorage } from "@nens/react/hooks";
import { getLocaleStringFromBrowserSetting } from "@nens/shared-utils";

/*
  <LocaleProvider> component

  - Puts locale and setLocale function into a Context.
  - Save the locale choice to local storage.
  - Update local storage with setLocale.
*/

export interface LocaleContextProps {
  locale: string;
  setLocale: (l: string) => void;
  supportedLocales: string[];
}

export const LocaleContext = createContext<LocaleContextProps>({
  locale: "en",
  setLocale: () => null,
  supportedLocales: ["en"],
});

interface LocaleProviderProps {
  supportedLocales: string[];
  defaultLocale: string;
}

export function LocaleProvider({
  supportedLocales,
  defaultLocale,
  children,
}: PropsWithChildren<LocaleProviderProps>) {
  const localeFromBrowserSetting = getLocaleStringFromBrowserSetting(
    supportedLocales,
    defaultLocale
  );
  const [locale, setLocale] = useLocalStorage("locale", localeFromBrowserSetting);

  return (
    <LocaleContext.Provider value={{ locale, setLocale, supportedLocales }}>
      {children}
    </LocaleContext.Provider>
  );
}

export default LocaleProvider;
